<template>
  <div :class="['lr-modal', {'hide': !show}]">
    <div class="lr-box">
      <div v-if="!driver.found">
        <img src="https://www.opoli.com/wp-content/themes/opoli/img/loading-car.gif" />
        <div class="lyft-msg" v-html="msg"></div>
        <a :class="['op-btn btn-block btn-danger', {disabled: loading}]" @click="cancel">
          <span v-if="cancelLoading">
            <i class="fas fa-spinner fa-spin"></i>
            Cancelling. . .
          </span>
          <span v-else>{{ $t('common.cancel') }}</span>
        </a>
      </div>
      <div v-else class="d-box">
        <div class="d-title">We found you a driver!</div>
        <div class="d-rsvp">RSVP ID: {{ rsvpId }}</div>
        <div class="d-flex driver-box align-start drvr">
          <img :src="driver.img" />
          <div class="d-info">
            <label>ID:</label>
            <div>{{ driver.id }}</div>
            <label>Name:</label>
            <div>{{ driver.name }}</div>
            <label v-if="driver.mobile">Mobile:</label>
            <div v-if="driver.mobile">{{ driver.mobile }}</div>
            <label>Rating:</label>
            <div>{{ driver.rating }}</div>
          </div>
        </div>
        <div class="d-flex driver-box align-start">
          <img :src="vehicle.img" />
          <div class="d-info">
            <label>Model:</label>
            <div>{{ `${vehicle.year} ${vehicle.make} ${vehicle.model}` }}</div>
            <label>License Plate:</label>
            <div>{{ vehicle.licensePlate }}</div>
            <label>Color:</label>
            <div>{{ vehicle.color }}</div>
          </div>
        </div>
        <a class="op-btn btn-block btn-success" @click="close">Close</a>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import moment from 'moment-timezone'
import xcurrency from '@/modules/api/currency'
import ft from '@/modules/api/featureToggle'
export default {
  name: 'asap-lyft',
  data () {
    return {
      loading: false,
      cancelLoading: false,
      currentBidID: '',
      msg: '',
      driver: {
        found: false,
        id: '',
        name: '',
        img: '',
        rating: '',
        mobile: ''
      },
      vehicle: {
        img: '',
        licensePlate: '',
        make: '',
        model: '',
        year: '',
        color: ''
      },
      rsvpId: '',
      statusDelay: '',
      success: false
    }
  },
  computed: {
    selectedCard () { return this.$store.state.selectedCard },
    rsvp () { return this.$store.state.reservation },
    lyft () { return this.rsvp.lyft },
    show: {
      get () { return this.lyft.show },
      set (x) {
        this.$store.commit('reservation/setLyftData', {show: x})
      }
    },
    leg1 () { return this.rsvp.leg1 },
    optin () { return this.rsvp.optin },
    mtech () { return this.rsvp.mtech },
    isRoundtrip () { return this.rsvp.isRoundtrip },
    user () { return this.$store.state.user },
    isCorporate () { return this.user.isCorporate },
    other () { return this.$store.state.other },
    currency () { return this.other.currency },
    tip () { return this.$store.state.tip.amount },
    credits () { return this.$store.state.credits },
    meetAndGreetFee () {
      let result = 0
      let rsvp = this.rsvp
      let leg1 = rsvp.leg1
      if (leg1.isAirportPickup) result += parseInt(leg1.pickupFee)
      return result
    },
    airportFee () {
      let result = 0
      if (this.leg1.airportFee) result += parseFloat(this.leg1.airportFee)
      return result
    },
    gasFee () {
      if (this.mtech.enabled) return 0
      let result = 0
      let rsvp = this.rsvp
      if (rsvp.leg1.selectedService && rsvp.leg1.services[rsvp.leg1.selectedService].gasFee) {
        result += parseFloat(rsvp.leg1.services[rsvp.leg1.selectedService].gasFee)
      }
      return result
    },
    travelInsurance () {
      if (this.mtech.enabled) return 0
      let rsvp = this.rsvp
      let total = 0
      if (rsvp.leg1.selectedService) {
        total = parseFloat(rsvp.leg1.services[rsvp.leg1.selectedService].travelInsurance)
      }
      return total
    },
    subtotal () {
      if (this.mtech.enabled) {
        let rsvp = this.leg1
        if (rsvp.selectedService) {
          let service = this.mtech.leg1.services[rsvp.selectedService]
          return service.price.breakdown[0].amount + service.price.addMarkup
        }
        return 0
      }
      let rsvp = this.rsvp
      let leg1 = rsvp.leg1
      let result = 0
      if (leg1.selectedService) {
        let serviceData = leg1.services[leg1.selectedService]
        let servicePricing = serviceData.prices[leg1.passenger - 1]
        result = servicePricing.price
      }
      return result
    },
    total () {
      if (this.mtech.enabled) {
        let total = this.subtotal + this.tip
        let rsvp = this.leg1
        if (rsvp.selectedService) {
          let breakdown = this.mtech.leg1.services[rsvp.selectedService].price.breakdown
          for (let i = 1; i < breakdown.length; i++) {
            total += breakdown[i].amount
          }
        }
        total = total - this.credits
        return total >= 0 ? total : 0
      }
      // let total = this.$store.state.fare +
      let total = this.subtotal +
        this.$store.state.tip.amount +
        this.meetAndGreetFee +
        this.airportFee +
        this.gasFee +
        this.travelInsurance -
        this.credits
      return total >= 0 ? total : 0
    },
    discountCode () { return this.$store.state.discountCode },
    savedTimezone () { return this.$store.state.reservation.timezones }
  },
  methods: {
    initLyftAsap () {
      let self = this
      // if (self.loading) return
      // self.loading = true
      let guestInfo = self.$store.state.guestInfo
      let guestMobile = guestInfo.countryCode + guestInfo.mobile
      if (guestMobile) { guestMobile = '+' + guestMobile }
      let guest = guestInfo.proxy ? {
        firstName: guestInfo.firstName,
        lastName: guestInfo.lastName,
        mobile: guestMobile,
        countryCode: guestInfo.countryCode,
        nationalNumber: guestInfo.mobile
      } : null
      if (self.isCorporate) {
        guest = {
          firstName: guestInfo.firstName,
          lastName: guestInfo.lastName,
          mobile: guestMobile,
          countryCode: guestInfo.countryCode,
          nationalNumber: guestInfo.mobile
        }
      }
      let selectedService = self.leg1.selectedService
      let lyftService = self.leg1.services[selectedService]
      let cardId = this.selectedCard.id
      let storeUser = this.user
      if (storeUser.isCorporate && storeUser.isDirectBilling) cardId = null
      let params = {
        token: self.user.token,
        brandId: self.$store.state.brandId,
        guest: guest,
        lyft: {
          ride_type: lyftService.ride_type,
          cost_token: lyftService.cost_token
        },
        legs: [
          self.buildLeg(),
          null
        ],
        payment: {
          cardID: cardId,
          tip: this.tip,
          total: this.total.toFixed(2),
          fare: this.total.toFixed(2),
          pickupFee: this.meetAndGreetFee,
          promo: this.credits
        },
        wheelchair: this.$store.state.wheelChair,
        serviceDog: this.$store.state.serviceDog,
        source: 'C',
        deviceType: 'ww'
      }
      self.msg = 'Processing your booking. . .'
      self.currentBidID = ''
      self.success = false
      self.$sdk.post(self, '/bid/lyft/create', params, r => {
        self.loading = false
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message.replace('backend.', '')
          })
          self.show = false
          return
        }
        self.currentBidID = r.bid.bidId
        self.msg = 'Searching for nearby drivers. . .'
        self.getLyftStatus(r)
      }, '2.0')
    },
    buildLeg () {
      let flightNumber = ''
      let flightName = ''
      let flightNumberDropoff = ''
      let flightNameDropoff = ''
      let rsvp = this.leg1
      if (rsvp.isAirportPickup) {
        flightNumber = rsvp.flightNo
        flightName = rsvp.airline
      }
      if (!rsvp.isAirportPickup && rsvp.isAirportDropoff) {
        flightNumberDropoff = rsvp.flightNo
        flightNameDropoff = rsvp.airline
      }
      let serviceData = rsvp.services[rsvp.selectedService]
      let fare = serviceData.prices[rsvp.passenger - 1].price
      let orig = serviceData.prices[rsvp.passenger - 1].original
      let gasFee = 0
      if (!this.mtech.enabled) {
        gasFee = serviceData.gasFee
      }
      let legData = {
        pickup: {
          address1: rsvp.pickup.address1,
          address2: rsvp.pickup.address2,
          city: rsvp.pickup.city,
          state: rsvp.pickup.state,
          zip: rsvp.pickup.zip,
          lat: rsvp.pickup.lat,
          lng: rsvp.pickup.lng,
          title: rsvp.pickup.title,
          geofenceId: rsvp.pickup.geofenceId
        },
        dropoff: {
          address1: rsvp.dropoff.address1,
          address2: rsvp.dropoff.address2,
          city: rsvp.dropoff.city,
          state: rsvp.dropoff.state,
          zip: rsvp.dropoff.zip,
          lat: rsvp.dropoff.lat,
          lng: rsvp.dropoff.lng,
          title: rsvp.dropoff.title,
          geofenceId: rsvp.dropoff.geofenceId
        },
        pickupTime: moment().unix(),
        passengers: rsvp.passenger,
        luggage: rsvp.luggage,
        amount: fare,
        originalPrice: orig,
        airportFee: serviceData.airportFee,
        gasFee: gasFee,
        flightNumber: flightNumber,
        flightName: flightName,
        dropoffFlightName: flightNameDropoff,
        dropoffFlightNumber: flightNumberDropoff,
        asap: true,
        etaInSec: rsvp.eta,
        serviceTypeId: serviceData.id,
        pickupType: rsvp.pickupType,
        pickupFee: rsvp.pickupFee,
        distance: rsvp.distance,
        notes: this.$store.state.driverNotes.leg1
      }
      if (!this.mtech.enabled) {
        delete legData.serviceType
        legData.serviceTypeId = serviceData.id
        legData.travelInsurance = serviceData.travelInsurance
      }
      if (!this.$store.state.isManualTip) {
        legData.tip = this.$store.state.tip.leg1
      }
      if (this.optin.leg1.enabled) {
        let pricing = this.isRoundtrip ? 'roundtrip' : 'prices'
        let origPrice = serviceData[pricing][(rsvp.passengers || 1) - 1].price
        let percent = serviceData.optinPercent / 100
        percent = parseFloat((1 - percent).toFixed(2))
        legData.optinShared = {
          serviceTypeId: serviceData.id,
          amount: parseFloat((origPrice * percent).toFixed(2))
        }
      }
      if (this.discountCode.id && this.discountCode.amount) {
        let pricing = this.isRoundtrip ? 'roundtrip' : 'prices'
        legData.amount = serviceData[pricing][rsvp.passenger - 1].price
      }
      if (this.currency.code !== 'USD') {
        let tip = this.$store.state.tip.intl
        if (this.isRoundtrip) tip = parseFloat((tip / 2).toFixed(2))
        legData.currency = {
          code: this.currency.code,
          exchangeRate: this.currency.value,
          amount: this.applyCurrency(legData.amount, false),
          tipAmount: tip,
          pickupFee: this.applyCurrency(rsvp.pickupFee, false),
          airportFee: this.applyCurrency(rsvp.airportFee, false),
          gasFee: this.applyCurrency(gasFee, false),
          travelInsurance: legData.travelInsurance ? this.applyCurrency(legData.travelInsurance, false) : 0
        }
        if (this.currency.code === 'JPY') {
          legData.currency.amount = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.amount}, false).replaceAll(',', ''))
          legData.currency.tipAmount = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.tipAmount}, false).replaceAll(',', ''))
          legData.currency.pickupFee = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.pickupFee}, false).replaceAll(',', ''))
          legData.currency.airportFee = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.airportFee}, false).replaceAll(',', ''))
          legData.currency.gasFee = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.gasFee}, false).replaceAll(',', ''))
          legData.currency.travelInsurance = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.travelInsurance}, false).replaceAll(',', ''))
        }
      }

      let pickupData = legData.pickup
      let tzData = this.savedTimezone.find(x => parseFloat(x.lat) === parseFloat(pickupData.lat) && parseFloat(x.lng) === parseFloat(pickupData.lng))
      if (tzData) {
        legData.pickupTimezone = tzData.timezone
      }

      return legData
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) {
        return parseFloat(x.toFixed(2))
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
      // return removeSymbol ? x.toFixed(2) : `${this.currency.symbol}${x.toFixed(2)}`
    },
    getLyftStatus (data) {
      let self = this
      if (self.statusDelay) clearTimeout(self.statusDelay)
      self.$sdk.post(self, '/bid/lyft/status', {
        token: self.user.token,
        bidId: data.bid.bidId
      }, r => {
        if (self.statusDelay) clearTimeout(self.statusDelay)
        if (r.status === 'canceled') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'No Driver found. Please try again later.'
          })
          self.show = false
          return
        }
        if ((r.rsvpId || r.status === 'accepted') && r.lyft.driver) {
          self.success = true
          self.show = false
          self.$store.commit('global/setAsapSuccessData', {
            show: true,
            rsvpId: r.rsvpId,
            driver: {
              found: true,
              id: r.lyft.driver.id,
              name: r.lyft.driver.first_name,
              img: r.lyft.driver.image_url,
              rating: r.lyft.driver.rating,
              mobile: r.lyft.driver.phone_number || ''
            },
            vehicle: {
              img: r.lyft.vehicle.image_url,
              licensePlate: r.lyft.vehicle.license_plate,
              make: r.lyft.vehicle.make,
              model: r.lyft.vehicle.model,
              year: r.lyft.vehicle.year,
              color: r.lyft.vehicle.color
            }
          })
          r.bidId = data.bid.bidId
          self.setTrackingData(r)
          return
        }
        self.statusDelay = setTimeout(() => {
          self.getLyftStatus(data)
        }, 5000)
      }, '2.0')
    },
    setTrackingData (data) {
      let self = this
      self.$sdk.get(self, `/reservations/${data.rsvpId}/${self.user.firstName}/${self.user.lastName}`, {}, rsvp => {
        if (rsvp.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: rsvp.error.message.replace('backend.', '')
          })
          return
        }
        let dispatchStatus = rsvp.dispatchStatus
        if (rsvp.status === 'ontheway' || rsvp.status === 'arrived') {
          dispatchStatus = 'ontheway'
        }
        let flightNumber = rsvp.flightNumber || ''
        let flightName = rsvp.airline || ''
        if (rsvp.dropoffAirline) {
          flightNumber = rsvp.dropoffFlightNumber
          flightName = rsvp.dropoffAirline
        }
        if (rsvp.optinShared && rsvp.optinShared.isOptinShared && rsvp.optinShared.current === 'shared') {
          rsvp.breakdown.fare = rsvp.optinShared.exclusive.amount
          rsvp.breakdown.total = rsvp.optinShared.exclusive.amount + rsvp.breakdown.airportFee + rsvp.breakdown.pickupFee + rsvp.breakdown.tip + rsvp.breakdown.travelInsurance - rsvp.breakdown.promo
        }
        let rsvpData = {
          id: rsvp.ID,
          bidID: rsvp.bidID,
          brandID: rsvp.brandID,
          consumer: rsvp.consumer,
          provider: rsvp.provider,
          vehicle: rsvp.vehicle,
          pickupTime: moment(rsvp.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(self, false)),
          pickup: rsvp.pickupLocation,
          dropoff: rsvp.dropoffLocation,
          distance: rsvp.distance,
          eta: rsvp.etaInSec,
          guest: rsvp.guest,
          payment: rsvp.breakdown,
          originalPrice: rsvp.originalPrice,
          notes: rsvp.notes,
          passengers: rsvp.passengers,
          luggage: rsvp.luggage,
          airline: flightName,
          airlineCode: rsvp.airlineCode,
          terminal: rsvp.terminal,
          flightNumber: flightNumber,
          pickupType: rsvp.pickupType === '' || rsvp.pickupType === 'N/A' ? null : rsvp.pickupType,
          cardTitle: rsvp.cardTitle,
          cardNumber: rsvp.cardNumber,
          cardID: rsvp.cardID,
          isAsap: true,
          serviceLabel: rsvp.serviceType.name,
          serviceCode: 'a' + rsvp.serviceType.id,
          serviceId: rsvp.serviceType.id,
          dispatchStatus: dispatchStatus,
          ada: {
            wheelchair: rsvp.ada.wheelChairLift === 1,
            serviceDog: rsvp.ada.serviceDog === 1
          },
          pickupTimezone: rsvp.pickupTimezone || 'America/Los_Angeles',
          rating: rsvp.rating,
          hasExtraStop: rsvp.hasExtraStop,
          isCharter: rsvp.isCharter,
          gasFee: rsvp.gasFee || 0,
          pkgId: rsvp.packageID,
          isMtech: rsvp.isMTech || false,
          rawPickupDate: rsvp.pickupDate,
          mtechService: rsvp.mtechProductData,
          discountCode: rsvp.corporateProfile && rsvp.corporateProfile.id ? rsvp.corporateProfile.discountCode : '',
          isCorporate: typeof rsvp.corporateProfile === 'object',
          isLyft: true,
          lyft: rsvp.lyft || null
        }
        if (rsvp.lyft) {
          rsvpData.serviceLabel = rsvp.lyft.custom_name
        }
        let pickupData = rsvpData.pickup
        let tzData = self.savedTimezone.find(x => parseFloat(x.lat) === parseFloat(pickupData.lat) && parseFloat(x.lng) === parseFloat(pickupData.lng))
        if (tzData) {
          rsvpData.pickupTimezone = tzData.timezone
        }
        // Driver INFO
        rsvpData.provider.ID = data.lyft.driver.id
        rsvpData.provider.avatarUrl = data.lyft.driver.image_url
        rsvpData.provider.firstName = data.lyft.driver.first_name
        rsvpData.provider.lastName = data.lyft.driver.last_name || ''
        rsvpData.provider.rating = data.lyft.driver.rating || 0
        rsvpData.provider.email = data.lyft.driver.email || ''
        rsvpData.provider.phones = [{
          countryCode: '',
          phoneNumber: data.lyft.driver.phone_number
        }]
        // Vehicle INFO
        rsvpData.vehicle.photo = data.lyft.vehicle.image_url
        rsvpData.vehicle.manufacturer = data.lyft.vehicle.make
        rsvpData.vehicle.model = data.lyft.vehicle.model
        rsvpData.vehicle.plate = data.lyft.vehicle.license_plate

        self.$store.commit('rsvpTrack/setRsvp', rsvpData)
        document.body.classList.add('widget-full')
        self.$root.$router.push('rsvp-track')
        // window.location = '#/rsvp-track'
      })
    },
    cancel () {
      let self = this
      if (self.loading || self.cancelLoading) return
      self.cancelLoading = true
      if (self.statusDelay) clearTimeout(self.statusDelay)
      self.$sdk.post(self, '/bid/lyft/cancel', {
        token: self.user.token,
        bidId: self.currentBidID
      }, r => {
        self.cancelLoading = false
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message.replace('backend.', '')
          })
          self.show = false
          return
        }

        self.show = false
      }, '2.0')
    },
    close () {
      if (this.loading) return
      this.show = false
      if (this.success) window.location.href = window.location.origin
    },
    checkTimezone () {
      if (this.loading) return
      this.loading = true

      let coords = []
      let rsvp = this.$store.state.reservation
      let leg1 = rsvp.leg1
      if (this.savedTimezone.length) {
        if (!this.savedTimezone.find(x => parseFloat(x.lat) === parseFloat(leg1.pickup.lat) && parseFloat(x.lng) === parseFloat(leg1.pickup.lng))) {
          coords.push({
            lat: leg1.pickup.lat,
            lng: leg1.pickup.lng
          })
        }
      } else {
        coords.push({
          lat: leg1.pickup.lat,
          lng: leg1.pickup.lng
        })
      }

      if (!coords.length) {
        this.initLyftAsap()
        return
      }
      this.getTimezone(coords)
    },
    getTimezone (coords) {
      let self = this
      if (!coords.length) {
        this.initLyftAsap()
        return
      }
      let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&lang=en-US&apiKey={API_KEY}&show=tz'
      url = url.replace('{AT}', encodeURIComponent(coords[0].lat + ',' + coords[0].lng))
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) { console.log('timezone err:', err) }
        if (body.items.length) {
          self.$store.commit('reservation/addTimezone', {
            lat: coords[0].lat,
            lng: coords[0].lng,
            timezone: body.items[0].timeZone.name
          })
        }
        coords.shift()
        self.getTimezone(coords)
      })
    }
  },
  watch: {
    show (val) {
      // if (val) this.initLyftAsap()
      if (val) this.checkTimezone()
    }
  }
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.05s ease;
  -moz-transition: all 0.05s ease;
  -o-transition: all 0.05s ease;
  transition: all 0.05s ease;
  .lr-box {
    background: #fff;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 3px 3px 2px rgba(0,0,0, .3);
    text-align: center;
    width: 100%;
    max-width: 500px;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  &.hide {
    z-index: -1;
    opacity: 0;
    display: none !important;
    .lr-box{
      transform: scale(90%) translateY(30px);
    }
  }
}
.lyft-msg{
  letter-spacing: .5px;
  margin-top: 5px;
}
.btn-danger{
  margin-top: 20px;
}
.d-box{
  text-align: left;
}
.d-title{
  font-size: 24px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
  text-align: center;
}
.d-rsvp{
  text-align: left;
  margin-bottom: 10px;
  letter-spacing: .7px;
  background: #333;
  padding: 2px 5px;
  color: #fff;
  display: inline-block;
  border-radius: 2px;
}
.driver-box{
  gap: 15px;
  
  &.drvr{
    margin-bottom: 20px;
    border-bottom: 1px dashed #eee;
  }
  img{
    width: 200px;
  }
  .d-info{
    width: calc(100% - 200px);
    text-align: left;
    line-height: 1;
    label{
      color: #555;
      font-size: 12px;
      letter-spacing: .7px;
      display: inline-block;
      margin-bottom: 2px;
    }
    div{
      font-weight: 600;
      margin-bottom: 8px;
      font-size: 17px;
    }
  }
}
.btn-success{
  margin-top: 25px;
}
</style>


// WEBPACK FOOTER //
// AsapLyftModal.vue?4b4aa3da